import { BASVURU_ISIM_DEGISIKLIK_KONU_GUNCELLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const basvuruIsimDegisiklikKonuGuncelle = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  
  return postRequest({ url: BASVURU_ISIM_DEGISIKLIK_KONU_GUNCELLE, data });
}

export default basvuruIsimDegisiklikKonuGuncelle;